import { createContext } from "react";
import { ConfirmOptions } from "./types";

export default createContext<(confirmProps: ConfirmOptions) => Promise<void>>(
  () => new Promise(() => {})
);
